

const BannerMsg = ({ msg, type }) => {
    return (
    <span className="banner-message">{msg}</span>
    )
}

export default BannerMsg;